<template>
    <section class="hero is-background-light is-fullheight">
      <div class="hero-body">
        <div class="container">
          <h1 class="Graphit-Bold introduction">
            {{ brandsText.brands_title }}
          </h1>
          <h2 class="subtitle Rational-Book">
            {{ brandsText.brands_description }}
          </h2>
          <div class="tags">
            <span
              class="tag responsive-tag"
              :key="brand.id"
              v-for="brand in brands"
            >
              {{ brand.title }}
            </span>
            <span class="tag responsive-tag">...</span>
          </div>
        </div>
      </div>
    </section>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'Brands',
  data() {
    return {
      pageTitle: 'Brands',
      pageSubtitle: 'I am thankful to have the chance to innovate customer experiences for strong brands',
    };
  },
  computed: {
    ...mapState([
      'brands',
    ]),
    brandsText () {
      return this.$store.getters.getBrandsText;
    }
  },
  mounted() {
    this.$store.dispatch('UPDATE_BRANDS');
  },
};
</script>
